var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13.417 6.844V1H4.563C3.973 1 3.5 1.46 3.5 2.031V21.97c0 .57.474 1.03 1.063 1.03h14.875c.588 0 1.062-.46 1.062-1.031V7.875h-6.02c-.585 0-1.063-.464-1.063-1.031zm2.833 10.14c0 .284-.24.516-.531.516H8.28a.525.525 0 01-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516v.343zm0-2.75c0 .284-.24.516-.531.516H8.28a.525.525 0 01-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516v.343zm0-3.093v.343c0 .284-.24.516-.531.516H8.28a.525.525 0 01-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516zm4.25-4.903V6.5h-5.667V1h.27c.284 0 .554.107.753.3l4.334 4.212c.2.193.31.455.31.726z"
  }))));
}

export default SvgDocument2;